import { usePageLayout } from '../Context/PageLayoutContext';

export const usePageLayoutContent = () => {
  const { content, snackbar, setSnackbarState, headerActions } = usePageLayout();

  return {
    content,
    snackbar,
    setSnackbarState,
    headerActions,
  };
};
